let setCurrentLightbox = null;
let setCurrentPreview = null;
let hoverDelay;
const previewListeners = [];

export const onPreviewChange = (callback) => {
  previewListeners.push(callback);
  return () => {
    const idx = previewListeners.indexOf(callback);
    if (idx > -1) previewListeners.splice(idx, 1);
  };
};

const notifyPreviewChange = (previewDetails) => {
  previewListeners.forEach((cb) => cb(previewDetails));
};

export const openLightbox = (lightboxDetails) => {
  if (lightboxDetails) {
    setCurrentLightbox(lightboxDetails);
  }
  setCurrentPreview("");
  notifyPreviewChange(null);
};

export const updateLightbox = (dataFromChild) => {
  setCurrentLightbox = dataFromChild;
};

export const handleHover = (previewDetails, type) => {
  clearTimeout(hoverDelay);
  if (type == "mouseenter") {
    hoverDelay = setTimeout(() => {
      setCurrentPreview(previewDetails);
      notifyPreviewChange(previewDetails);
    }, 250);
  }
};

export const updatePreview = (dataFromChild) => {
  setCurrentPreview = dataFromChild;
};
